import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-trip-review',
  templateUrl: './user-trip-review.component.html',
  styleUrls: ['./user-trip-review.component.scss'],
})
export class UserTripReviewComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
